import React from 'react';
import * as cls from './what-makes-different.module.css';
import { Link } from 'react-router-dom';
import { IMG_PATH, ROUTES_PATHS } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { Button } from '../../../../ui/components/button';

const items = [
  {
    imgAlt:
      'Voltaware sensor next to a standard credit card for size comparison.',
    img: `${IMG_PATH}/our-technology/hardware/size-comparison.png`,
    icon: `${IMG_PATH}/our-technology/hardware/size-comparison-ico.svg`,
    title: 'Ultra-slim, credit-card sized',
    text: 'Sits neatly in the fuse box. One sensor per home covers the whole property.',
  },
  {
    imgAlt:
      'High-resolution waveform with segments labelled EV, washing machine, fridge and cooker - 10,000+ samples/sec.',
    img: `${IMG_PATH}/our-technology/hardware/high-resolution-signal-capture.png`,
    icon: `${IMG_PATH}/our-technology/hardware/high-resolution-signal-capture-ico.svg`,
    title: 'High-resolution signal capture',
    text: (
      <>
        Samples voltage and current <b>10,000+ times per second</b>, enabling
        major appliance detection and richer insights.
      </>
    ),
  },
  {
    imgAlt:
      'Installer attaching magnetic voltage probes to the breaker; clamp on mains cable - no rewiring.',
    img: `${IMG_PATH}/our-technology/hardware/plug-and-play.png`,
    icon: `${IMG_PATH}/our-technology/hardware/plug-and-play-ico.svg`,
    title: <strong>Plug & play, non-intrusive</strong>,
    text: (
      <>
        Clamp on the mains cable; magnetic probes sample voltage on the breaker.
        No rewiring. Typical install in <b>under 5 minutes</b>.
      </>
    ),
  },
  {
    imgAlt:
      'Cloud sending OTA updates to multiple sensors with cadence slider from real-time to periodic; Firmware/AI/Security badges.',
    img: `${IMG_PATH}/our-technology/hardware/future-proof.png`,
    icon: `${IMG_PATH}/our-technology/hardware/future-proof-ico.svg`,
    title: 'Future-proof by default',
    text: 'Fleet-wide OTA updates to firmware, AI classifiers, and security let you switch between near-real-time and periodic uploads, roll out features in stages, and keep programmes evolving - no engineer visits, no hardware swaps.',
  },
  {
    imgAlt:
      'Close-up of Voltaware’s patented magnetic connectors for faster, reliable installation.',
    img: `${IMG_PATH}/our-technology/hardware/patented-magnetic-connectors.png`,
    icon: `${IMG_PATH}/our-technology/hardware/patented-magnetic-connectors-ico.svg`,
    title: 'Patented magnetic connectors',
    text: 'Our globally patented design improves reliability and installation speed, providing durable advantages in the field.',
  },
  {
    imgAlt:
      'Diagram showing smart-meter totals complemented by Voltaware appliance-level insights.',
    img: `${IMG_PATH}/our-technology/hardware/smart-meter.png`,
    icon: `${IMG_PATH}/our-technology/hardware/smart-meter-ico.svg`,
    title: 'Smart-meter compatible',
    text: 'Complements smart-meter data and enhances it with appliance-level intelligence.',
    action: (
      <Link to={ROUTES_PATHS.SMART_METER_INTEGRATION}>
        <Button variant="green-transparent">Read More</Button>
      </Link>
    ),
  },
];

export const WhatMakesDifferent = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        What Makes Our Hardware Different
      </Typography>

      {items.map((item, index) => (
        <div className={cls.item} key={index}>
          <div className={cls.textWrapper}>
            <div>
              <img src={item.icon} alt="" />
              <Typography>{item.title}</Typography>
            </div>
            <Typography>{item.text}</Typography>
            {item.action}
          </div>
          <div className={cls.imgWrapper}>
            <img src={item.img} alt={item.imgAlt} />
          </div>
          {item.action}
        </div>
      ))}
    </Section>
  );
};
